<template>
  <div>
    <validation-observer ref="auctionObserver" method="post">
      <table class="table">
        <tr>
          <th>
            オークション
            <br v-if="!isMobile" />
            会場
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row mb-2">
              <label class="d-inline mt-2 ml-3 pr-2">都道府県</label>
              <validation-provider v-slot="{ errors }">
                <b-form-select
                  v-model="searchCond.TODO_CD"
                  :state="errors.length ? false : null"
                  :options="prefList"
                  trim
                  @change="search"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
            <div>
              <validation-provider v-slot="{ errors }" rules="required">
                <b-form-select
                  v-model="selectedItem"
                  :state="errors.length ? false : null"
                  :options="aaList"
                  :disabled="!aaList.length"
                  trim
                  @change="selectedAA"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </td>
        </tr>
      </table>
    </validation-observer>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin'

const HIKINO_SAKI = {
  AA_KAISAI_BI: null,
  YUBIN1: null,
  YUBIN2: null,
  TODO_CD: null,
  TODO_MEI: null,
  SHIKU_CD: '',
  SHIKU_MEI: null,
  BANCHI: null,
  MEI: null,
  TEL: null,
  TANTO_MEI: null,
  TANTO_TEL: null,
  YUSO_KBN: '',
  HCB_ZOKUSEI_CD: null,
  LANDMARK_KBN: null,
  TEIKYU_BI: [],
  EIGYO_KAISI_JIKAN: '',
  EIGYO_SYURYO_JIKAN: '',
  TOROKUBAYO_KO_ID: null,
  HANNYUSYUTU_JIKAN: null,
  AA_CD: null,
  AA_ID: null,
}

const DATA_KBN = 'AUCTION'

export default {
  name: 'Auction',
  mixins: [Mixin],

  props: {
    /** オークション取得フラグ */
    isGetAaFlg: {
      type: Boolean,
      default: false,
    },

    /** 検索条件 */
    _searchCond: {
      type: Object,
      default: null,
    },

    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** バリデーション実行フラグ */
    isValid: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isLoading: false,

    /** 市区町村リスト */
    cityList: [],

    /** 検索条件 */
    searchCond: {
      TODO_CD: null,
    },

    /** オークションリスト */
    aaList: [],

    /** オークション選択データ*/
    selectedItem: null,
  }),

  methods: {
    /** バリデーション実行 */
    validate() {
      this.$v.$touch()
    },

    /** オークション引取先選択 */
    selectedAA() {
      const item = this.selectedItem
      if (!item) {
        return this.$emit('setData', {}, DATA_KBN)
      }
      const data = {
        AA_KAISAI_BI: null,
        AA_CD: item.AA_CD,
        AA_ID: item.id,
        TOROKUBAYO_KO_ID: null,
        YUBIN1: item.YUBIN_BANGO1,
        YUBIN2: item.YUBIN_BANGO2,
        TODO_CD: item.TODO_CD,
        TODO_MEI: item.TODO_MEI,
        SHIKU_CD: item.SHIKU_CD,
        SHIKU_MEI: item.SHIKU_MEI,
        BANCHI: item.BANCHI,
        MEI: item.name,
        TEL: item.HCB_TEL || item.TEL,
        YUSO_KBN: null,
        HCB_ZOKUSEI_CD: item.HCB_ZOKUSEI_CD,
        LANDMARK_KBN: null,
        TANTO_MEI: null,
        TANTO_TEL: null,
        TEIKYU_BI: null,
        EIGYO_KAISI_JIKAN: null,
        EIGYO_SYURYO_JIKAN: null,
        HANNYUSYUTU_JIKAN: null,
      }
      this.$emit('setData', data, DATA_KBN)
    },

    /** オークション入力データを初期化する */
    reset() {
      this.aaList = []
      this.selectedItem = null
      this.$emit('reset', DATA_KBN)
    },

    /** 検索する */
    async search() {
      this.reset()
      await this.getAAList()
    },

    /** オークションリスト取得 */
    getAAList() {
      this.isLoading = true
      const prefCd =
        this.searchCond.TODO_CD !== '' ? this.searchCond.TODO_CD : null
      return this.getAuctions(prefCd).then((res) => {
        this.aaList = res.data.map((v) => {
          return {
            value: v,
            text: v.name,
          }
        })
        this.aaList.unshift({ text: '未選択', value: null })
        this.isLoading = false
      })
    },

    /** オークション状況を再現する */
    async revival() {
      const cond = this._searchCond
      this.searchCond.TODO_CD = cond.TODO_CD
      await this.search()
      const item = this.aaList.filter(
        (v) =>
          v.value && (v.value.id === cond.AA_ID || v.value.AA_CD === cond.AA_CD)
      )[0]
      if (item) {
        this.selectedItem = item.value
        this.selectedAA()
      }
    },
  },

  watch: {
    /** ローディングフラグ */
    isLoading(val) {
      this.$emit('loaded', val, DATA_KBN)
    },

    /** 検索実行フラグ */
    async isSearch(val) {
      if (val) {
        if (this._searchCond) {
          this.revival()
        } else {
          await this.search()
        }

        this.$emit('searched', DATA_KBN)
      }
    },

    /** バリデーション実行フラグ */
    async isValid(val) {
      if (val) {
        const invalid = await this.$refs.auctionObserver.validate()
        this.$emit('setInvalid', !invalid, DATA_KBN)
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.table-wrapper
  overflow: auto
  //height: 780px
  @include sp
    overflow: hidden
    height: auto
    max-height: 100%
.form-check-inline
  margin-right: 5px
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
</style>



// WEBPACK FOOTER //
// src/components/order/Auction.vue